// extracted by mini-css-extract-plugin
export default {"link":"a9YhBi","clickable":"dX12nb","svgRoot":"AKxYR5","nonScalingStroke":"VZYmYf","hasShadow":"vv0uGt"};